import React, { useState } from 'react';
import flashlight from '../assets/flashlight.png';
import menuIcon from '../assets/menu-bar.png';

const Banner = ({ onToggleCandle }) => {
    const [isActive, setIsActive] = useState(false);

    return (
        <nav
            className="
            select-none
        navbar  
        fixed 
        top-0
        left-0
        w-full
        flex
        justify-between
        items-center
        pt-2
        pb-2
        px-3
        text-white
        font-bold
        text-base
        bg-black/40
        md:pt-5
        md:pb-5
        md:px-10
        md:text-2xl
      "
            style={{ zIndex: 100000000 }}
        >
            <div className="logo-and-button flex items-center gap-4">
                <button
                    type="button"
                    onClick={onToggleCandle}
                    className="
            relative 
            group 
            bg-transparent 
            border-none 
            p-0 
            m-0 
            focus:outline-none
          "
                >
                    {/* Glow layer */}
                    <div
                        className="absolute inset-0 flex items-center justify-center pointer-events-none"
                        aria-hidden="true"
                    >
                        <div
                            className="
                w-32 h-32 
                rounded-full 
                bg-purple-300
                opacity-90
                blur-[80px]
                mix-blend-mode: screen
                transition-all
                duration-300
                group-hover:opacity-100
                group-hover:blur-[100px]
              "
                        />
                    </div>

                    {/* Flashlight icon with hover scale */}
                    <img
                        src={flashlight}
                        alt="Light Button"
                        className="
              w-8 
              h-auto 
              relative 
              md:w-12
              transform
              transition-transform 
              duration-300
              group-hover:scale-110
            "
                    />
                </button>

                <div className="text-yellow font-bold font-imfellenglish">
                    ← sealuminate the way
                </div>
            </div>

            {/* Menu Toggle (hamburger) */}
            <button
                className="
          nav-toggle 
          block 
          md:hidden 
          border-none 
          bg-transparent 
          w-10 
          h-10 
          cursor-pointer
        "
                onClick={() => setIsActive(!isActive)}
            >
                <img
                    src={menuIcon}
                    alt="Menu"
                    className={`
            w-full 
            h-auto 
            transition-transform 
            duration-300
            transform
            ${isActive ? 'rotate-90' : 'rotate-0'}
          `}
                />
            </button>

            {/* Mobile Drawer vs. Desktop Nav */}
            <ul
                className={`
          md:flex md:static md:bg-transparent md:w-auto md:relative md:flex-row
          ${
              isActive
                  ? 'fixed top-[56px] bottom-0 right-0 w-[27%] h-[20%] bg-black flex flex-col pl-5 z-40 rounded-xl'
                  : 'hidden'
          }
          nav-links gap-4 text-white font-imfellenglish text-xl md:text-2xl
        `}
                style={{ zIndex: 100000001 }}
            >
                <li className="mt-2 md:mt-0">
                    <a
                        href="https://memes.hornsworld.xyz"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => setIsActive(false)}
                        className="
              inline-block 
              transition-all 
              duration-300 
              /* color + scale on hover */
              hover:text-yellow 
              hover:scale-110
            "
                    >
                        pfp|meme
                    </a>
                </li>

                <li className="mt-0 md:mt-0">
                    <a
                        href="https://x.com/sealuminati"
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={() => setIsActive(false)}
                    >
                        <img
                            src="https://d39nah1etu3fy9.cloudfront.net/images/assets/sealuminati/website/x.png"
                            alt="X"
                            className="
                w-4 
                h-auto 
                md:w-4 
                inline
                ml-1
                /* scale on hover */
                transition-transform 
                duration-300
                hover:scale-110
              "
                        />
                    </a>
                </li>
            </ul>
        </nav>
    );
};

export default Banner;
